import Tutor from "../components/ads/SearchTutor";
import SEO from "../components/SEO";

function Search() {
  return (
    <div className="page p-1">
      <SEO
        title="Search Tutors — Tutoring Platform"
        description="Find qualified tutors across subjects and contact them directly."
        image="/logo192.png"
      />
      <Tutor />
      
    </div>
  );
}

export default Search;
